import { render, staticRenderFns } from "./FilteredSelectFacets.vue?vue&type=template&id=f1f616d2&"
import script from "./FilteredSelectFacets.vue?vue&type=script&lang=js&"
export * from "./FilteredSelectFacets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports